import { Component } from '@angular/core';
import { Modal } from 'bootstrap';
import { ListComponent } from 'src/app/common/component/list.component';

import { PhpTasksListFiltersComponent as FiltersComponent } from './php-tasks-list-filters/php-tasks-list-filters.component';

@Component({
	selector: 'app-php-tasks-list',
	templateUrl: './php-tasks-list.component.html',
	styleUrls: ['./php-tasks-list.component.css'],
})
export class PhpTasksListComponent extends ListComponent {
	protected itemsBeforeDataLoad = 3;
	protected apiUrl = 'tasks';
	tableRows = [
		{ id: 'created', name: 'Utwrzono' },
		{ id: 'authorName', name: 'Autor' },
		{ id: 'typeName', name: 'Rodzaj' },
		{ id: 'deadline', name: 'Termin' },
		{ id: 'content', name: 'Opis' },
		{ id: 'objTypeName', name: 'Obiekt' },
		{ id: 'statusName', name: 'Status' },
	];
	parameters = {
		statuses: [],
		tasksTypes: [],
		tasksObjTypes: [],
		users: [],
	};

	protected loadBefore() {
		this.api.get('/tasksStatuses/', (result, error) => {
			this.parameters.statuses = result.data;
		});
		this.api.get('/tasksTypes/', (result, error) => {
			this.parameters.tasksTypes = result.data;
			this.loadData();
		});
		this.api.get('/tasksObjTypes/', (result, error) => {
			this.parameters.tasksObjTypes = result.data;
			this.loadData();
		});
		this.api.get('/users/', (result, error) => {
			this.parameters.users = result.data;
		});
		this.loader.hide();
	}

	protected convertData(data) {
		data.forEach((obj) => {
			const type = this.parameters.tasksTypes.find((findObj) => findObj.id == obj.type);
			obj.typeName = type ? type.name : '?';
			const objType = this.parameters.tasksObjTypes.find((findObj) => findObj.id == obj.objType);
			obj.objTypeName = objType ? objType.name : '?';
			obj.objLink = objType ? '/' + objType.link.replace('[id]', obj.objId) : '';
			const status = this.parameters.statuses.find((findObj) => findObj.id == obj.status);
			obj.statusName = status.name;
			const author = this.parameters.users.find((findObj) => findObj.id == obj.author);
			obj.authorName = author?.lastName + ' ' + author?.firstName;
		});
		return data;
	}

	addOpen() {
		new Modal(document.getElementById('taskAddModal')).show();
	}

	addDone() {
		this.loadData();
		const modal = Modal.getInstance(document.getElementById('taskAddModal'));
		if (!modal) {
			return;
		}
		modal.hide();
	}
}
